import React from "react";
import { Circle } from "./styled";
import { useSelector } from "react-redux";
import { selectedArticles } from "../../../../../../../../../../../../../store/Concept/selectors";
import { mark } from "../../functions";

const Flag = ({ value, row }) => {
  const items = useSelector(selectedArticles);

  if (!mark(items, value) || row.original.amount) {
    return null;
  }

  return <Circle />;
};

export default Flag;
